var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("jade-list-item", {
    attrs: {
      label: _vm.file.name,
      variant: _vm.fileDetails.listItemVariant,
      description: _vm.$t(_vm.fileDetails?.description, { limit: _vm.limit }),
    },
    scopedSlots: _vm._u([
      {
        key: "leading",
        fn: function () {
          return [
            _c("jade-icon", {
              attrs: {
                use: _vm.fileDetails.iconUse,
                color: _vm.fileDetails.iconVariant,
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "trailing",
        fn: function () {
          return [
            _c("jade-icon-button", {
              attrs: {
                icon: "trash",
                size: "medium",
                variant: _vm.fileDetails.buttonVariant,
                disabled: _vm.fileIsLoading,
              },
              on: { click: _vm.deleteFile },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }